import { InteractionRequiredAuthError } from '@azure/msal-browser';

const INTERACTION_REQUIRED_CODES = new Set([
  'monitor_window_timeout',
  'iframe_closed_prematurely',
  'block_nested_popups',
  'login_required',
  'interaction_required',
  'consent_required',
]);

/**
 * Returns true when MSAL requires user interaction (popup/redirect) to get a token.
 * Includes BrowserAuthError codes such as iframe timeouts that are not InteractionRequiredAuthError.
 */
export function isInteractionRequired(error: unknown): boolean {
  if (error instanceof InteractionRequiredAuthError) {
    return true;
  }

  const code =
    (error as { errorCode?: string } | null)?.errorCode ??
    (error as { code?: string } | null)?.code;

  return typeof code === 'string' && INTERACTION_REQUIRED_CODES.has(code);
}
